import { makeStyles } from "tss-react/mui";
const styles = makeStyles()((theme)=>({
        label: {
            fontSize: theme.tokens.typography.variant.caption.fontSize,
            marginBottom: theme.px(10)
        },
        caption: {
            fontSize: theme.tokens.typography.variant.caption.fontSize,
            color: theme.tokens.colors.text.light.tertirary
        }
    }));
const FormKnownValue_styles = styles;
export default FormKnownValue_styles;
